import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const DEFAULT_TITLE = "Group Health Plans & PEO Options for Employers | The Woodlands, TX";

/**
 * Titles for the pages SeoManager deliberately leaves alone (the unsubscribe page).
 * On public routes this is a no-op so it cannot overwrite the SEO head tags.
 */
export function usePageTitle(title) {
  const { pathname } = useLocation();
  useEffect(() => {
    if (!pathname.startsWith("/unsubscribe")) return;
    document.title = title ? `${title} | OneHarvestCo. Benefits` : DEFAULT_TITLE;
  }, [title, pathname]);
}
